export * from './Paragraph';
try {
    // @ts-ignore
    Paragraph.displayName = "Paragraph";
    // @ts-ignore
    Paragraph.__docgenInfo = { "description": "", "displayName": "Paragraph", "props": { "theme": { "defaultValue": null, "description": "", "name": "theme", "required": false, "type": { "name": "any" } }, "as": { "defaultValue": null, "description": "Typing Note: prefer using .withComponent for now as it is actually type-safe.\n\nString types need to be cast to themselves to become literal types (as={'a' as 'a'}).", "name": "as", "required": false, "type": { "name": "\"symbol\" | \"object\" | \"a\" | \"abbr\" | \"address\" | \"area\" | \"article\" | \"aside\" | \"audio\" | \"b\" | \"base\" | \"bdi\" | \"bdo\" | \"big\" | \"blockquote\" | \"body\" | \"br\" | \"button\" | \"canvas\" | ... 154 more ... | FunctionComponent<...>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Paragraph/index.ts#Paragraph"] = { docgenInfo: Paragraph.__docgenInfo, name: "Paragraph", path: "src/components/Paragraph/index.ts#Paragraph" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    ParagraphDocz.displayName = "ParagraphDocz";
    // @ts-ignore
    ParagraphDocz.__docgenInfo = { "description": "", "displayName": "ParagraphDocz", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Paragraph/index.ts#ParagraphDocz"] = { docgenInfo: ParagraphDocz.__docgenInfo, name: "ParagraphDocz", path: "src/components/Paragraph/index.ts#ParagraphDocz" };
}
catch (__react_docgen_typescript_loader_error) { }